<template>
  <div class="container-upload">
    <div class="upload-row">
      <q-file
        :accept="config.accept"
        standout
        dense
        v-model="file"
        :display-value="labelFile"
        max-files="1"
        :multiple="false"
        @input="getFile"
        class="bSecondary"
        input-class="inputClass"
        :max-file-size="config.maxFileSize"
        @rejected="onRejected"
      >
        <template v-slot:prepend>
          <q-icon
            class='upload-icon2'
            :name="'img:' + require('@/assets/img/upload-icon.svg')"
          />
        </template>
      </q-file>
    </div>
  </div>
</template>
<script>
import Formats from '@/components/shared/mixins/Formats.js';
import Message from '@/components/shared/mixins/Message.js';

export default {
  mixins: [Formats, Message],
  props: {
    label: String,
    value: {
      required: true
    }
  },
  data () {
    return {
      file: this.value,
      labelFile: this.label,
      config: {
        accept: '.pdf',
        maxFileSize: 10485760
      }
    };
  },
  methods: {
    async getFile () {
      this.$emit('input', this.file);
    },
    onRejected () {
      this.showError(`No es un fichero valido, debe ser .pdf y tamaño maximo 10MB`);
    }
  },
  mounted () {
    this.$eventHub.$on('vaciaFile', () => {
      this.file = null;
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('vaciaFile');
  },
  watch: {
    value: {
      handler: function () {
        this.file = this.value;
      },
      immediate: true
    },
    label: {
      handler: function () {
        this.labelFile = this.label;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/style.scss";
.container-upload{
  padding-top: 0px !important;
}

</style>
